module.exports = __webpack_public_path__ + "img/img_flag_vi.76e28a6e.png";